<script lang="ts">

    import { toCanvas } from 'qrcode';
    import { onMount } from 'svelte';
    import { CLIENT_URL } from '../../environment';
import { gamesService } from '../../Services';

    export let roomId: string;
    export let gameId: string = undefined;
    export let margin = 4;
    export let width = 500;
    export let dark = '#000000ff';
    export let light = '#ffffffff';

    let canvas: HTMLCanvasElement;

    onMount(() => updateQr(roomId, gameId));

    $: updateQr(roomId, gameId);

    async function updateQr(roomId: string, gameId: string): Promise<void> {
        if (!canvas)  {
            return;
        }

        const roomUrl = new URL(`/room/${roomId}`, CLIENT_URL);

        if (gameId) {
            try {
                const game = await gamesService.getGame(gameId);
                roomUrl.searchParams.set('gameCode', game.code);
            } catch (error) {
                console.warn('Ha ocurrido un error al obtener el juego para generar el código QR');
                console.error(error);
            }
        }

        toCanvas(canvas, roomUrl.href, {
            margin,
            width,
            color: {
                dark,
                light,
            }
        });

    }

</script>

<canvas bind:this={canvas}></canvas>

<style lang="scss">

    canvas {
        width: auto !important;
        height: auto !important;
        max-width: 100%;
        max-height: 100%;
        min-height: 0;
    }

</style>
